import React from 'react';
import CaseStudys from '../index';
import styles from './styles.module.scss';
import AJTechBanner from '../../../assets/casestudy/AJTechBanner.webp';
import AJTech1stimg from '../../../assets/casestudy/A.G. Tech Industries.webp';
import genuiunimg from '../../../assets/casestudy/genuiunimg.png';
import KumarPhotography from '../../../assets/casestudy/KumarPhotoGraphy.webp';
import Ajtech2ndimg from '../../../assets/casestudy/ajtech2ndimg.webp';
import Ajtech3rndimg from '../../../assets/casestudy/ajtech3rndimg.webp';
// Replace with the actual Hostec project image
import Wordpressicon from '../../../assets/img/wordpressicon.svg';

const Hostec = () => {
  const caseStudiesB = [
{
    image: KumarPhotography,
    title: 'Kumar Photography',
    category: 'Website Design',
    link: 'https://kumarsphoto.com/',
     pagelink:'/ajtechIndustry',
  },
{
    image: genuiunimg,
    title: 'Genuine IT Systems',
    category: 'Website Design',
     pagelink:'/genuineitsystems',
    link: 'https://www.genitsgroup.com/',
},
];
  const servicesB = [
  { label: 'UI & UX Design', link: 'https://metasoft.ae/services' },
  { label: 'Web Development', link: 'https://metasoft.ae/services' },
  { label: 'Performance Optimization', link: 'https://metasoft.ae/services'},
  { label: 'SEO', link: 'https://metasoftdm.com/marketing-solutions/seo/'},
];
  return (
    <CaseStudys
    caseStudies={caseStudiesB} 
 
      title="A.G. Tech Industries"
      subtitle="Crafting a Visual Platform for a Visual Brand"
      header='Shaping a strong online presence to highlight industrial expertise.'
      industry="Industrial Automation"
      websiteUrl='https://agtechindustries.com/'
      services={servicesB}
      description={
        <>
          <span>A G Tech Industries,</span>  based in Hubli since 2017, specializes in valve automation and risk management for industrial systems. They provide a wide range of valves and automation solutions, along with expert services for installation, audits, and safety compliance. Focused on quality and reliability, they support industries with efficient, tailored solutions.
        </>
      }
      objective={{
        heading: 'Creating a Seamless Online Presence to Elevate A.G. Tech Industries Innovation',
        content: (
          <>
            <p className={styles.projectText}>
            The objective of designing the AgTech Industries website was to create a visually appealing, user-friendly platform that effectively communicates the company’s expertise in agricultural technology. The goal was to provide a seamless browsing experience across devices, with easy access to key information about their products and services. By focusing on clarity, navigation, and responsiveness, the website aims to strengthen the brand's presence and establish AgTech Industries as a leader in innovation within the ag-tech sector.
            </p>

           
          </>
        ),
      }}
      process={{
        heading: "From Concept to Code: Building a Platform for AgTech Excellence",
        content: (
          <>
            <p className={styles.projectText}>
           The design process for AgTech Industries’ website involved a detailed and user-centric approach. The team focused on understanding the needs of the agricultural technology sector and its audience, ensuring that the design was clean, modern, and easy to navigate. The layout was structured with clear calls to action, making it easy for visitors to access essential information. The website was also optimized for responsiveness, offering a seamless experience across different devices. Through this thoughtful design process, the website successfully highlights AgTech Industries’ expertise and commitment to innovation in the agricultural tech space.
            </p>

         

          
          </>
        ),
      }}
      impact={{
        heading: 'Building a Stronger Online Image for AgTech Industries',
        content: (
          <>
            <p className={styles.projectText}>
           The newly designed website serves as a centralized hub for A G Tech Industries, allowing potential clients to explore their diverse product offerings, understand their engineering capabilities, and engage with their services. It provides detailed information on various valve types, automation solutions, and engineering services, enhancing user experience and engagement.
            </p>
          
          </>
        ),
      }}
       conclusion={{
        heading: 'Wrapping Up the Project',
        content: (
          <>
            <p className={styles.projectText}>
          In conclusion, the AgTech Industries website successfully meets its objective of providing a modern, intuitive platform that showcases the company’s commitment to innovation in agricultural technology. The clean design, responsive features, and clear navigation ensure that visitors can easily find the information they need, enhancing the overall user experience. This website not only reflects the company’s expertise but also strengthens its digital presence, positioning AgTech Industries as a forward-thinking leader in the ag-tech industry.
            </p>
           
          </>
        ),
      }}
      heroImage={AJTechBanner} // Add the hero image
      projectImage={AJTech1stimg} 
         projectImage2={Ajtech2ndimg}// Add the project image
             projectImage3={Ajtech3rndimg}
      technologies={[
        { name: 'Word Press', icon: Wordpressicon },
    
      ]} // Add the technologies used
      timescale="8 Weeks" // Add the timescale
      launchDate="September 2024" // Add the launch date
    />
  );
};

export default Hostec;